import { Component, Input, ViewChild } from "@angular/core";
import { CountdownComponent } from 'ngx-countdown';

@Component({
    selector: 'awscognito-mfa',
    templateUrl: './mfa.component.html'
})
export class MfaComponent {

    @ViewChild('countDown') countDown: CountdownComponent;

    @Input() destination: string;
    @Input() onSubmit: (code: string) => void;
    @Input() errorMessage: string;
    @Input() userName: string;
    @Input() tiempoMfa: number;
    @Input() validarCodigo: boolean;

    constructor() { }

    resetTimer() {
        this.countDown.restart();
    }

    stopTimer() {
        this.countDown.stop();
    }

}